import type { ProtectedRoute } from '../../../protectedRoutes.types.ts';

const PROTECTED_ROUTES: ProtectedRoute[] = [];

export { PROTECTED_ROUTES };
